/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: frLTK57AGre4oWC8c14hh8
// Component: VmHDhDPiJD3u

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: frLTK57AGre4oWC8c14hh8/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: frLTK57AGre4oWC8c14hh8/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicFooterSection.module.css"; // plasmic-import: VmHDhDPiJD3u/css

createPlasmicElementProxy;

export type PlasmicFooterSection__VariantMembers = {};
export type PlasmicFooterSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicFooterSection__VariantsArgs;
export const PlasmicFooterSection__VariantProps = new Array<VariantPropType>();

export type PlasmicFooterSection__ArgsType = {};
type ArgPropType = keyof PlasmicFooterSection__ArgsType;
export const PlasmicFooterSection__ArgProps = new Array<ArgPropType>();

export type PlasmicFooterSection__OverridesType = {
  root?: Flex__<"div">;
};

export interface DefaultFooterSectionProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFooterSection__RenderFunc(props: {
  variants: PlasmicFooterSection__VariantsArgs;
  args: PlasmicFooterSection__ArgsType;
  overrides: PlasmicFooterSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_frLTK57AGre4oWC8c14hh8",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames("all", sty.freeBox__pQle7)}>
        <div className={classNames("all", sty.freeBox__tDnyA)}>
          <div className={classNames("all", "__wab_text", sty.text__c1Roo)}>
            {
              "Povinn\u00e9 informace - FinBakers pracuje s partnersk\u00fdmi poskytovateli z \u010cesk\u00e9 republiky, kte\u0159\u00ed jsou koncov\u00fdm dodavatelem finan\u010dn\u00edch slu\u017eeb. Informace o na\u0161ich partnerech, v\u010detn\u011b z\u00e1kladn\u00edch \u00fadaj\u016f, kontakn\u00edch informac\u00ed a odkaz\u016f na web, jsou um\u00edst\u011bny na str\u00e1nce Dodavatel\u00e9. Individu\u00e1ln\u00ed z\u00e1jemci o finan\u010dn\u00ed produkty mus\u00ed b\u00fdt osoby star\u0161\u00ed 18 let, mus\u00ed m\u00edt platn\u00fd trval\u00fd pobyt na \u00fazem\u00ed \u010cesk\u00e9 republiky a bankovn\u00ed \u00fa\u010det veden\u00fd u jedn\u00e9 z \u010desk\u00fdch bank. V\u0161echny \u017e\u00e1dosti o p\u016fj\u010dku jsou p\u0159edm\u011btem schvalovac\u00edho procesu dodavatele. Va\u0161e \u00farokov\u00e1 m\u00edra se m\u016f\u017ee li\u0161it v z\u00e1vislosti na v\u00fd\u0161i \u00fav\u011bru, d\u00e9lce spl\u00e1cen\u00ed, \u00fa\u010delu a spl\u00e1tkov\u00e9 historii.\n\n\r\n\r\nFinBakers nab\u00edz\u00ed \u00fav\u011bry s \u00farokovou m\u00edrou od 2.99% (RPSN 3.62%) a\u017e 279.83% (RPSN 1141.2%) a splatnost\u00ed 3 a\u017e 120 m\u011bs\u00edc\u016f. RPSN a v\u00fd\u0161e \u00fav\u011bru se li\u0161\u00ed podle typu produktu a dodavatele. V\u0161echny zobrazen\u00e9 v\u00fdpo\u010dty a \u00fadaje jsou orienta\u010dn\u00ed. FinBakers neposkytuje radu dle \u00a7 85 z\u00e1kona o spot\u0159ebitelsk\u00e9m \u00fav\u011bru c. 257/2016 Sb."
            }
          </div>
          <div className={classNames("all", "__wab_text", sty.text__wGmQl)}>
            {
              "FinBakers s.r.o.\nI\u010cO: 091 515 41\nNa Folimance 2155/15, Vinohrady (Praha 2), 120 00 Praha\nspole\u010dnost zapsan\u00e1 v obchodn\u00edm rejst\u0159\u00edku veden\u00e9m M\u011bstsk\u00fdm soudem v Praze pod sp. zn. C 331699.\n"
            }
          </div>
          <div className={classNames("all", sty.freeBox__civcz)}>
            <div className={classNames("all", sty.freeBox___4JvZp)}>
              <PlasmicLink__
                className={classNames(
                  "all",
                  "a",
                  "a__frLTK",
                  "__wab_text",
                  sty.link__nywP2
                )}
                component={Link}
                href={`/gdpr`}
                legacyBehavior={false}
                platform={"nextjs"}
                target={"_blank"}
              >
                {"Z\u00e1sady ochrany osobn\u00edch \u00fadaj\u016f"}
              </PlasmicLink__>
              <PlasmicLink__
                className={classNames(
                  "all",
                  "a",
                  "a__frLTK",
                  "__wab_text",
                  sty.link__ilsmY
                )}
                component={Link}
                href={`/terms`}
                legacyBehavior={false}
                platform={"nextjs"}
                target={"_blank"}
              >
                {"V\u0161eobecn\u00e9 obchodn\u00ed podm\u00ednky"}
              </PlasmicLink__>
              <PlasmicLink__
                className={classNames(
                  "all",
                  "a",
                  "a__frLTK",
                  "__wab_text",
                  sty.link__lwWca
                )}
                component={Link}
                href={`/remarketing`}
                legacyBehavior={false}
                platform={"nextjs"}
                target={"_blank"}
              >
                {"Zpracov\u00e1n\u00ed osobn\u00edch \u00fadaj\u016f"}
              </PlasmicLink__>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFooterSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFooterSection__VariantsArgs;
    args?: PlasmicFooterSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFooterSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFooterSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFooterSection__ArgProps,
          internalVariantPropNames: PlasmicFooterSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFooterSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicFooterSection";
  } else {
    func.displayName = `PlasmicFooterSection.${nodeName}`;
  }
  return func;
}

export const PlasmicFooterSection = Object.assign(
  // Top-level PlasmicFooterSection renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicFooterSection
    internalVariantProps: PlasmicFooterSection__VariantProps,
    internalArgProps: PlasmicFooterSection__ArgProps
  }
);

export default PlasmicFooterSection;
/* prettier-ignore-end */
